import { render, staticRenderFns } from "./HistoryTabTemplate.vue?vue&type=template&id=60f7e257&scoped=true"
import script from "./HistoryTabTemplate.vue?vue&type=script&lang=js"
export * from "./HistoryTabTemplate.vue?vue&type=script&lang=js"
import style0 from "./HistoryTabTemplate.vue?vue&type=style&index=0&id=60f7e257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f7e257",
  null
  
)

export default component.exports